import {observer} from 'mobx-react';
import SparePartsFinderSOIndexTableRow from '../SparePartsFinderSOIndexTableRow';

const IndexTableRow = observer(
    class SPFSOCartIndexTableRow extends SparePartsFinderSOIndexTableRow {

        renderDescriptionContainer() {
            return (
                <div className="text-search-index-table-row">
                    <div className="basket-description">
                        {this.renderDescription()}
                        {this.props.row.searchParameters.length > 1 && this.renderSOs()}
                    </div>
                    {this.renderBlocks()}
                </div>
            )
        }

        renderSOs() {
            return (
                <span
                    className="products">&nbsp;({__('for SO: ')}&nbsp;{this.props.row.searchParameters.join(', ')})</span>
            )
        }

        renderActions() {
            return <React.Fragment/>
        }

        createRowKey() {
            return `${super.createRowKey()}-modal`
        }

        createCheckboxId() {
            return `${super.createCheckboxId()}-modal`
        }

        renderActions() {
            return <React.Fragment/>
        }

        renderRowInternalActions() {
            return <React.Fragment/>
        }
    }
)

export default IndexTableRow;